<sales-loader [@fadeInOut] *ngIf="loading$ | async"></sales-loader>
<dgx-ui-wl-header
  [clientLogoPath]="(clientLogoPath$ | async) || ''"
  [navigationLinks]="headerNavigationLinks"
></dgx-ui-wl-header>
<main>
  <router-outlet></router-outlet>
</main>
<sales-footer></sales-footer>
